// extracted by mini-css-extract-plugin
export default {"divMain":"Header_divMain__BQhLd","scroll":"Header_scroll__qaExJ","brand":"Header_brand__UBp7v","divBtn":"Header_divBtn__jiXB9","nav":"Header_nav__ZeDKq"};